function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var ConquistadorsTemplate = require('./conquistadors.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var ConquistadorsOverlay = /*#__PURE__*/function () {
  function ConquistadorsOverlay(app, mod) {
    _classCallCheck(this, ConquistadorsOverlay);
    this.app = app;
    this.mod = mod;
    this.visible = false;
    this.overlay = new SaitoOverlay(app, mod);
  }
  return _createClass(ConquistadorsOverlay, [{
    key: "hide",
    value: function hide() {
      this.visible = false;
      this.overlay.hide();
    }
  }, {
    key: "render",
    value: function render() {
      var faction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var his_self = this.mod;
      this.visible = true;
      this.overlay.show(ConquistadorsTemplate());
      for (var key in his_self.conquistadors) {
        var unavailable = '';
        var exp = his_self.conquistadors[key];
        this.app.browser.addElementToSelector("<div class=\"conquistadors-tile ".concat(key, "\" data-key=\"").concat(key, "\" data-id=\"").concat(key, "\" style=\"background-image:url('").concat(his_self.conquistadors[key].img, "')\"></div>"), '.conquistadors-overlay');
      }
      for (var i = 0; i < his_self.game.state.conquests.length; i++) {
        var con = his_self.game.state.conquests[i];
        if (con.conquistador_lost == 1) {
          var obj = document.querySelector(".".concat(con.conquistador));
          if (obj) {
            obj.classList.add('opaque');
          }
        }
      }
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {}
  }]);
}();
module.exports = ConquistadorsOverlay;